import { render } from "./SessionsOverview.vue?vue&type=template&id=e5e35818"
import script from "./SessionsOverview.vue?vue&type=script&lang=js"
export * from "./SessionsOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__